<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Nicholson left international finance at the age of 46 with enough money to start travelling the world for fun. He published his first book in 2017, <em>Mr Tambourine Man,</em> written from his dreams detailing his adventures. He then went on to write two novels, <em>The Tell-tale and My Back Pages.</em> He has lived happily in Cornwall for the last twenty-three years with his loving wife of 42 years, Chrissie, and has a 33-year-old daughter, Lauren, whom he adores.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?31318346